





































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import { ApiService } from '@/api/api.service'
import { formatRelativeDate } from '@/filters/formatRelativeDate'
import find from 'lodash/find'
import concat from 'lodash/concat'
import difference from 'lodash/difference'
import { UserModule } from '@/store/modules/user'
import { nickname } from '@/utils/nickname'
import { getOperation, getOperationID } from '@/api/operations'
import { getModuleIcon } from '@/utils/getModuleIcon'
import { getNames } from '@/utils/getNames'
import { getBoUrl } from '@/api/http-constants'

@Component({
    filters: {
        formatRelativeDate,
    },
})
export default class Questionnaire extends Vue {
    @Prop() moduleID: number
    apiService = new ApiService()
    showSubmit = false
    questions = []
    module = null
    questionsWithResponse = []
    responses = []
    nickname: string
    opeName: string
    opeID: number
    userID: number
    boUrl = getBoUrl()

    getIcon(type: string): string {
        return getModuleIcon(this.module.type)
    }

    get names(): string[] {
        return getNames(
            this.module,
            this.nickname,
            this.opeName,
            this.opeID,
            this.userID
        )
    }

    @Watch('questions', { deep: true, immediate: true })
    onQuestions() {
        if (!this.questions) {
            this.questionsWithResponse = []
        }

        this.questionsWithResponse = this.questions.map(question => {
            const responseSubmited = find(this.responses, {
                question: {
                    id: question.id,
                },
            })

            let response = null
            switch (question.type) {
                case 'integer':
                case 'text':
                    response = responseSubmited ? responseSubmited.value : null
                    break
                case 'radio':
                    if (responseSubmited) {
                        const proposition = find(question.propositions, {
                            name: responseSubmited.value,
                        })
                        response = (proposition as any).id
                    } else {
                        response = null
                    }
                    break
                case 'checkbox':
                    if (responseSubmited) {
                        const propositionsSubmitted = JSON.parse(
                            responseSubmited.value
                        )
                        response = question.propositions.reduce(
                            (accu, proposition) => {
                                accu[proposition.id] =
                                    propositionsSubmitted.indexOf(
                                        proposition.name
                                    ) === -1
                                        ? false
                                        : true
                                return accu
                            },
                            {}
                        )
                    } else {
                        response = question.propositions.reduce(
                            (accu, proposition) => {
                                accu[proposition.id] = false
                                return accu
                            },
                            {}
                        )
                    }
                    break
            }

            const propositionWithImages = question.propositions.filter(
                proposition => proposition.imageName
            )
            const withImage =
                question.type === 'radio' || question.type === 'checkbox'
                    ? question.propositions.length ===
                      propositionWithImages.length
                    : false

            return {
                id: question.id,
                name: question.name,
                description: question.description,
                information: question.information,
                type: question.type,
                withImage,
                unity: question.unity,
                propositions: question.propositions.map(proposition => ({
                    id: proposition.id,
                    name: proposition.name,
                    imageName: proposition.imageName,
                })),
                response: response,
                answered: false,
            }
        })
    }
    questionIndex = 0
    slideDirection = 'slide-left'

    toggle(response, id) {
        const key = id.toString()
        response[key] = !response[key]
    }

    get question() {
        return this.questionsWithResponse[this.questionIndex]
    }

    /**
     * On détermine si une question a été répondue
     */
    @Watch('questionsWithResponse', { deep: true, immediate: true })
    onQuestionsWithResponse() {
        this.questionsWithResponse.forEach(question => {
            switch (question.type) {
                case 'integer':
                    question.answered =
                        question.response !== null &&
                        (question.response as any).trim() !== ''
                    break
                case 'text':
                    question.answered =
                        question.response !== null &&
                        (question.response as any).trim() !== ''
                    break
                case 'checkbox':
                    let nb = 0
                    Object.keys(question.response).forEach(key => {
                        nb += question.response[key] ? 1 : 0
                    })
                    question.answered = nb > 0
                    break
                case 'radio':
                    question.answered = question.response !== null
                    break
            }
        })
    }

    get nbAnswered() {
        let nbAnswered = 0
        this.questionsWithResponse.forEach(question => {
            nbAnswered += question.answered ? 1 : 0
        })
        return nbAnswered
    }

    get percent() {
        let percent = this.nbAnswered / this.questionsWithResponse.length
        percent *= 100
        return Math.floor(percent)
    }

    previousScreen() {
        this.slideDirection = 'slide-right'
        if (this.showSubmit) {
            this.showSubmit = false
        } else {
            this.previousQuestion()
        }
    }

    async nextScreen() {
        this.slideDirection = 'slide-left'
        this.submitResponse()
        if (this.questionIndex === this.questionsWithResponse.length - 1) {
            this.showSubmit = true
        } else {
            this.nextQuestion()
        }
    }

    previousQuestion() {
        let index = this.questionIndex
        index--
        this.questionIndex = Math.max(index, 0)
    }

    nextQuestion() {
        let index = this.questionIndex
        index++
        this.questionIndex = Math.min(
            index,
            this.questionsWithResponse.length - 1
        )
    }

    @Watch('moduleID', { deep: true, immediate: true })
    async onModuleID() {
        const resp = await this.apiService.getQuestions(this.moduleID)
        const questions = resp.data
        this.questions = questions
        console.log(JSON.parse(JSON.stringify(questions)))

        let responses = []
        for (let question of questions) {
            try {
                const responseResp = await this.apiService.getResponse(
                    question.id
                )
                const response = responseResp.data
                responses.push(response)
            } catch (e) {}
        }
        this.responses = responses
        console.log(JSON.parse(JSON.stringify(responses)))

        const resp2 = await this.apiService.getModule(this.moduleID)
        const module = resp2.data
        this.module = module

        this.onQuestions()
    }

    afterTransition() {
        if (this.$refs.focusElm) {
            ;(this.$refs.focusElm as HTMLElement).focus()
        }

        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    async submitResponse() {
        let response = null
        switch (this.question.type) {
            case 'integer':
            case 'text':
                response = this.question.response
                break
            case 'checkbox':
                let _responses = []
                for (let key in this.question.response) {
                    const proposition = find(this.question.propositions, {
                        id: parseInt(key, 10),
                    })

                    if (this.question.response[key]) {
                        _responses.push((proposition as any).name)
                    }
                }
                if (_responses.length === 0) {
                    response = null
                } else {
                    response = JSON.stringify(_responses)
                }
                break
            case 'radio':
                const proposition = find(this.question.propositions, {
                    id: this.question.response,
                })
                response = (proposition as any).name
                break
        }

        const responseSubmited = find(this.responses, {
            question: {
                id: this.question.id,
            },
        })

        if (!responseSubmited) {
            const responseResp = await this.apiService.postResponse({
                question: this.question.id,
                value: response,
            })
            const responseObj = responseResp.data
            this.responses = concat(this.responses, [responseObj])
        } else {
            await this.apiService.patchResponse(responseSubmited.id, {
                question: this.question.id,
                value: response,
            })
        }
    }

    done() {
        this.$emit('done')
    }

    async created() {
        await UserModule.Init()
        this.userID = UserModule.userInfos.id
        this.nickname = nickname(
            UserModule.userInfos.firstname,
            UserModule.userInfos.lastname
        )

        const opSlug = getOperation()

        const apiService = new ApiService()
        const allOpResp = await apiService.getAllOpe()
        const allOp = allOpResp.data
        const op: any = find(allOp, {
            slug: opSlug,
        })
        this.opeName = op.name
        this.opeID = await getOperationID()
    }
}
